import { ref, onMounted, onBeforeUnmount } from 'vue';

const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
];
const LOGO_CLICKS_TO_TRIGGER = 7;
const LOGO_CLICKS_WINDOW_MS = 3000;
const TYPING_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

// Bumped every time the easter egg is discovered; the raven watches it.
export const easterEggTrigger = ref(0);

const trigger = () => {
  easterEggTrigger.value += 1;
};

let logoClickTimes = [];

// Seven quick clicks on the logo.
export const registerLogoClick = () => {
  const now = Date.now();
  logoClickTimes = [
    ...logoClickTimes.filter(time => now - time < LOGO_CLICKS_WINDOW_MS),
    now,
  ];
  if (logoClickTimes.length < LOGO_CLICKS_TO_TRIGGER) return;
  logoClickTimes = [];
  trigger();
};

const isTyping = target =>
  target instanceof HTMLElement &&
  (target.isContentEditable || TYPING_TAGS.includes(target.tagName));

// ↑ ↑ ↓ ↓ ← → ← → B A, ignored while the user is typing in a field.
export const useKonamiCode = () => {
  let progress = 0;

  const onKeyDown = event => {
    if (isTyping(event.target)) return;
    const key = event.key.length === 1 ? event.key.toLowerCase() : event.key;
    progress =
      key === KONAMI_CODE[progress]
        ? progress + 1
        : Number(key === KONAMI_CODE[0]);
    if (progress < KONAMI_CODE.length) return;
    progress = 0;
    trigger();
  };

  onMounted(() => window.addEventListener('keydown', onKeyDown));
  onBeforeUnmount(() => window.removeEventListener('keydown', onKeyDown));
};
